jQuery(function ($) {

    // select data acf-selection in form
    const $formContainer = $('#form-container');
    if (!$formContainer.length) return;

    const valueToSet = $formContainer.data('acf-selection');
    const $select = $('#select-ministries');

    if (valueToSet && $select.length) {
        $(document).on('wpcf7init', function () {
            if ($select.find('option[value="' + valueToSet + '"]').length) {
                $select.val(valueToSet).trigger('change');
            }
        });

        if ($select.find('option[value="' + valueToSet + '"]').length) {
            $select.val(valueToSet).trigger('change');
        }
    }

    $(document).on('change', '.section-our-ministries-form input[type="file"]', function () {
        const $input = $(this);
        const $wrap = $input.closest('.wpcf7-form-control-wrap');
        const $name = $wrap.find('.file-upload-name');

        if (this.files && this.files.length) {
            $name.text(this.files[0].name);
        } else {
            $name.text('Файл не вибрано');
        }
    });

    $(document).on('wpcf7submit', '.section-our-ministries-form form.wpcf7-form', function (e) {
        const status = e.originalEvent.detail.status;
        console.log('STATUS:', status);

        if (status !== 'mail_sent') {
            return;
        }

        // hide form
        const $form = $(this);
        $form.hide();

        // add class for flex
        const $wrapper = $form.closest('.flex');
        $wrapper.addClass('align-center');

        // show success block
        const $success = $form.closest('.wpcf7').siblings('.success-block');
        if ($success.length) $success.show();
    });


});